export const CollectController = {
    store(): void {},
};
